import { ItemType, PageItem } from './types';

export function getPageItems({
  pagesCount,
  page,
}: {
  pagesCount: number;
  page: number;
}): Array<PageItem> {
  let items: Array<PageItem>;

  switch (pagesCount) {
    case 1: {
      return [];
    }
    case 2: {
      items = [1, 2];
      break;
    }
    case 3: {
      items = [1, 2, 3];
      break;
    }
    case 4: {
      items = [1, 2, 3, 4];
      break;
    }

    default: {
      if (page <= 2) {
        items = [1, 2, 3, ItemType.Dots, pagesCount];
      } else if (page === 3) {
        items = pagesCount === 5 ? [1, 2, 3, 4] : [1, 2, 3, 4, ItemType.Dots, pagesCount];
      } else if (pagesCount - page < 2) {
        items = [1, ItemType.Dots, pagesCount - 2, pagesCount - 1, pagesCount];
      } else if (pagesCount - page === 2) {
        items = [1, ItemType.Dots, pagesCount - 3, pagesCount - 2, pagesCount - 1, pagesCount];
      } else {
        items = [1, ItemType.Dots, page - 1, page, page + 1, ItemType.Dots, pagesCount];
      }
      break;
    }
  }
  // add first item only if not the first page
  if (page !== 1) {
    items = [ItemType.Start, ...items];
  }
  // add last item only if not the last page
  if (page !== pagesCount) {
    items = [...items, ItemType.End];
  }

  return items;
}
